import React, { useState, useEffect, useCallback } from 'react'
import './App.css'
import { getItems } from './api/waniKaniApiCalls'

import { UserDetails } from './components/UserDetails'
import { RequestForm } from './components/RequestForm'
import { Subjects } from './components/Subjects'
import logo from './img/bee-drill.svg'
import { paginateList } from './utils/paginate'

import { SRS_STAGES, RESOURCE_TYPES } from './constants'

function App() {
  const [apiKey, setApiKey] = useState('')
  const [userData, setUserData] = useState()
  const [subjects, setSubjects] = useState([])
  const [subject, setSubject] = useState()
  const [loading, setLoading] = useState(false)
  const [requestParams, setRequestParams] = useState({
    levels: '1',
    types: 'kanji',
    subject_types: 'kanji',
    started: true,
    srs_key: 'BURNED'
  })
  const [resourceType, setResourceType] = useState(RESOURCE_TYPES.ASSIGNMENTS)
  const [pageSize] = useState(36)
  const [pageNumber, setPageNumber] = useState(1)

  const loadUser = async () => {
    try {
      const userDataResponse = await getItems({
        apiKey: apiKey,
        resourceType: RESOURCE_TYPES.USER,
      })
      setRequestParams({ ...requestParams, levels: userDataResponse.data.level })
      setUserData(userDataResponse)

    } catch (error) {
      window.alert(error.message)
    }
  }

  useEffect(() => {
    setApiKey(window.localStorage.getItem('apiKey'))
  }, [])

  const loadSubjects = useCallback(async () => {
    if (userData && apiKey) {
      setLoading(true)

      try {

        const { levels, subject_types, types, started, srs_key } = requestParams

        const assignmentRequestParams = {
          subject_types,
          levels,
          srs_stages: SRS_STAGES[srs_key].stages
        }

        const assignments = await getItems({
          apiKey,
          resourceType,
          requestParams: assignmentRequestParams,
        })

        if(assignments.data.length > 0) {
          const assignmentSubjects = assignments.data.map(assignment => assignment.data.subject_id)
          const subjectRequestParams = {
            ids: assignmentSubjects.join(),
            types,
            levels,
            started,
          }
  
          const subjects = await getItems({
            apiKey,
            resourceType: RESOURCE_TYPES.SUBJECTS,
            requestParams: subjectRequestParams,
          })
          const paginatedData = paginateList([...subjects.data], pageSize)
  
          if (paginatedData.length > 0) {
            setSubjects(paginatedData)
            setSubject(paginatedData[0][0])
          }
        } else {
          setSubjects([])
        }


      } catch (error) {
        window.alert(error.message)
      } finally {
        setLoading(false)
      }
    }
  }, [apiKey, requestParams, pageSize, resourceType, userData])

  useEffect(() => {
    loadSubjects()
  }, [loadSubjects, requestParams.levels, requestParams.types, resourceType])

  const handleApiKeySubmit = async () => {
    window.localStorage.setItem('apiKey', apiKey)
    loadUser()
  }

  // TODO: Update to avoid repeating subject
  const handleRandomSubjectClick = () => {
    const randomPageIndex = Math.floor(Math.random() * subjects.length)
    const randomItemIndex = Math.floor(Math.random() * subjects[randomPageIndex].length)

    setPageNumber(randomPageIndex + 1)
    setSubject(subjects[randomPageIndex][randomItemIndex])
  }

  const handleLogoutClick = () => {
    setUserData(null)
  }

  // const handleLevelChange = (decrementIncrement) => {
  //   const newValue = decrementIncrement === 'decrement' ? requestParams.levels - 1 : requestParams.levels + 1

  //   setRequestParams({ ...requestParams, levels: newValue })
  // }

  return (
    <>
      <header>
        <img className="logo" src={logo} alt="bee drill logo" />
      </header>
      <div className="app">
        <main className="app-container">
          <div className="controls-container">
            {!userData &&
              <section>
                <div className="api-key-container">
                  <input
                    onChange={(e) => setApiKey(e.currentTarget.value)}
                    value={apiKey}
                    disabled={userData}
                    visible={userData}
                  />
                  <button className="api-key-btn" onClick={handleApiKeySubmit}>Login with API Key</button>
                  <p>Find your key <a href="https://www.wanikani.com/settings/personal_access_tokens">here</a></p>
                </div>
              </section>
            }
            {userData &&
              <>
                <UserDetails userData={userData} handleLogoutClick={handleLogoutClick} />
                <RequestForm
                  loadSubjects={loadSubjects}
                  resourceType={resourceType}
                  setResourceType={setResourceType}
                  requestParams={requestParams}
                  setRequestParams={setRequestParams}
                />

                {loading
                  ? <div>Loading...</div>
                  : <Subjects
                    handleRandomSubjectClick={handleRandomSubjectClick}
                    handleSubjectClick={setSubject}
                    pageNumber={pageNumber}
                    selectedSubjectId={subject?.id}
                    setPageNumber={setPageNumber}
                    subjects={subjects}
                  />
                }
              </>
            }
          </div>
          <div className="preview-container">
            <div className="selected-subject">
              <div className="subject-title">
                {subject?.data.characters}
              </div>
              <div className="subject-preview">
                <a
                  href={'http://www.jisho.org/search/' + subject?.data.characters + '%20%23kanji'}
                  title='View stroke order on Jisho'
                >
                  {subject?.data.characters}
                </a>
              </div>
              <div className="subject-meaning">{subject?.data.meanings[0].meaning}</div>
              <div className="subject-reading">
                <div className="preview-readings">
                  {
                    subject?.data?.readings?.map((readingItem, index) => {
                      return (
                        <div className="reading" key={`reading-${index}`}>
                          <div className="pronounciation">
                            {readingItem.reading}
                          </div>
                          <div className="reading-type">
                            {readingItem.type}
                          </div>
                        </div>
                      )
                    })
                  }
                </div>
              </div>
            </div>
          </div>
        </main>
        <p>ビードリル　is made possible thanks to the <a href="https://docs.api.wanikani.com">WaniKani API</a> and developed by a lot of great people</p>
      </div>
    </>
  )
}

export default App
